import React, { useCallback, useEffect, useState, useRef, use } from "react";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Topbar from "../../components/Topbar/Topbar";
import { get, post, put } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";

const WalletOwnerAdd = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const formType = location.state?.type;
  const useData = location.state?.userDatas;
  const isReject = location.state?.isReject;
  // const setReject = location.state?.setReject;

  const admin_details = JSON.parse(localStorage.getItem("admin_details"));
  const inputRef = useRef(null);
  const setReject = location.state?.setReject;

  const [showReason, setShowReason] = useState(isReject || false);
  // const isViewMode = formType === "view" || formType === "edit";
  const isViewMode = formType === "view" || (formType === "edit" && !setReject);
  console.log("useData", useData);
  const {
    control,
    handleSubmit,
    watch,
    setValue,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      state: null,
      city: null,
      owner: null,
      property: null,
      booking: null,
      WalletAmount: "",
      RequestedBy: admin_details?.name || "",
      Description: "",
      Reason: "",
    },
  });
  useEffect(() => {
    setShowReason(isReject);
  }, [isReject]);
  // Dropdown state
  const [lists, setLists] = useState({
    states: [],
    cities: [],
    owners: [],
    properties: [],
    booking: [],
  });

  const [loading, setLoading] = useState({
    states: false,
    cities: false,
    owners: false,
    properties: false,
  });

  const [bookingData, setBookingData] = useState(null);
  const getLocationsList = async (type, parent_id) => {
    let url = `${URLS.LOCATION}?type=${type}${parent_id ? `&parent_id=${parent_id}` : ""
      }`;
    const res = await get(url);
    if (res?.status === "success") {
      const modifiedList = res.data.map((item) => ({
        value: item.id,
        label: item.name,
      }));
      if (type === 2) {
        setLists((prev) => ({
          ...prev,
          states: modifiedList,
        }));
      }
    }
  };
  // ========== Fetch helper ==========
  const fetchDropdownData = useCallback(async (queryParams = {}, type) => {
    setLoading((prev) => ({ ...prev, [type]: true }));
    try {
      const query = new URLSearchParams(queryParams).toString();
      const url = `${URLS.OWNER_WALLET_DROPDOWNLIST}${query ? `?${query}` : ""
        }`;
      const res = await get(url);

      if (res?.status !== "success") throw new Error("API Error");
      const data = res?.data || {};

      const format = (arr = []) =>
        arr.map((i) => ({
          value: i.id,
          label: `${i.name}${i.mobile ? ` - ${i.mobile}` : ""}${i.code ? ` | ${i.code}` : ``
            }`,

          // label: `${i.name}${i.mobile ? `- ${i.mobile}` : ""} || i.code || ""}`,
        }));

      setLists((prev) => ({
        ...prev,
        states: type === "states" ? format(data) : prev.states,
        cities: type === "cities" ? format(data?.cities) : prev.cities,
        owners: type === "owners" ? format(data?.owners) : prev.owners,
        properties:
          type === "properties" ? format(data?.properties) : prev.properties,
      }));

      return data;
    } catch (err) {
      console.error(`Error fetching ${type}:`, err);
      if (type !== "states") setLists((prev) => ({ ...prev, [type]: [] }));
    } finally {
      setLoading((prev) => ({ ...prev, [type]: false }));
    }
  }, []);

  // ========== Load States ==========
  useEffect(() => {
    getLocationsList(2);
  }, []);
  // ========== Submit ==========
  const onSubmit = async (data) => {
    console.log("DADDDDDD", data);
    if (useData?.id) {
      console.log("SADAS", data);
      const value = {
        // user_id: data?.Use[0]?.value || data?.Use?.value,
        wallet_id: useData?.id,

        // wallet_id
        owner_id: data?.owner[0]?.value || data?.owner?.value,
        amount: data?.WalletAmount,
        description: data?.Description,
        // user_id: 0,
        // amount: 0,
        // description: "string",
        // reference_id: 0,
      };

      // Only add `reference_id` if booking is selected
      if (data?.Booking?.value) {
        value.reference_id = data.Booking.value;
      }

      console.log("VALUEEEEESSS", value);

      try {
        const res = await put(URLS.OWNER_WALLET_EDIT, value);
        console.log("documentupload", res);

        if (res?.status === "success") {
          toast.success("Transaction Wallet Update Successfully");
          reset();
          navigate("/wallet-owner");
        } else {
          toast.error(res?.message || "Failed to add wallet transaction");
        }
      } catch (error) {
        console.error("Error submitting transaction:", error);
        // toast.error("Something went wrong!");
      }
    } else {
      const value = {
        owner_id: data?.owner?.value,
        amount: data?.WalletAmount,
        description: data?.Description,
      };
      if (data?.booking?.value) {
        value.reference_id = data?.booking?.value;
      }
      console.log("DADDDDDD22", value);
      try {
        const res = await post(URLS.OWNER_WALLET_ADD, value);
        if (res?.status === "success") {
          toast.success("Transaction Wallet Added Successfully");
          reset();
          navigate("/wallet-owner");
        } else {
          toast.error(res?.message || "Failed to add wallet transaction");
        }
      } catch (err) {
        console.error("Submit Error:", err);
        // toast.error("Something went wrong!");
      }
    }
  };

  // ========== Approve / Reject ==========
  const accept = async () => {
    try {
      const payload = { wallet_ids: [useData?.id] };
      const res = await post(`${URLS.OWNER_WALLET_ACCEPT}`, payload);
      if (res.status === "success") {
        toast.success("Wallet approved successfully");
        navigate("/wallet-owner", {
          state: { type: "approved", tab: 2 },
        });
      }
    } catch (err) {
      console.error(err);
      toast.error("Error approving wallet");
    }
  };

  const reject = async (reason) => {
    if (!reason) {
      toast.error("Kindly add a reject reason");
      return;
    }
    try {
      const payload = { wallet_ids: [useData?.id], reason };
      console.log("PSDISDASD", payload);
      const res = await post(`${URLS.OWNER_WALLET_REJECT}`, payload);
      console.log("PSDISDASD----res", payload, res);
      if (res.status === "success") {
        toast.success("Wallet rejected successfully");
        navigate("/wallet-owner", {
          state: { type: "rejected", tab: 3 },
        });
      }
    } catch (err) {
      console.error(err);
      toast.error("Error rejecting wallet");
    }
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "#F4F4F4",
      borderRadius: 4,
      border: "none",
      padding: 5,
      width: "100%",
      boxShadow: "none",
      minHeight: "initial",
    }),
    placeholder: (provided) => ({ ...provided, color: "#999999" }),
  };

  // ========== Form UI ==========
  useEffect(() => {
    if (useData) {
      // Set Select values as { value, label }
      if (useData?.state_id && useData?.state) {
        setValue("state", {
          value: useData.state_id,
          label: useData.state,
        });
        fetchDropdownData({ state: useData.state_id }, "cities");
      }

      // Regular text fields
      setValue("WalletAmount", useData?.amount || "");
      setValue("RequestedBy", admin_details?.name || "");
      setValue("Description", useData?.description || "");
      setValue("Reason", useData?.reason || "");
    }
  }, [useData, setValue]);
  // useEffect(() => {
  //   if (useData?.city_id && useData?.city) {
  //     setValue("city", { value: useData.city_id, label: useData.city });
  //     fetchDropdownData(
  //       {
  //         state: watch("state").value,
  //         city: useData.city_id,
  //       },
  //       "owners"
  //     );
  //   }

  //   if (useData?.owner_id && useData?.owner_name) {
  //     setValue("owner", {
  //       value: useData.owner_id,
  //       label: `${useData.owner_name}${
  //         useData.owner_mobile ? ` - ${useData.owner_mobile}` : ""
  //       }${useData.owner_code ? ` | ${useData.owner_code}` : ""}`,
  //     });
  //     fetchDropdownData(
  //       {
  //         state: watch("state").value,
  //         city: watch("city").value,
  //         owner: useData.owner_id,
  //       },
  //       "properties"
  //     );
  //   }

  //   if (useData?.property?.code && useData?.property?.name) {
  //     setValue("property", {
  //       value: useData.property.id,
  //       label: `${useData.property.name}${
  //         useData.property.code ? ` | ${useData.property.code}` : ""
  //       }`,
  //     });
  //       if (
  //                       watch("state")?.value &&
  //                       watch("city")?.value &&
  //                       watch("owner")?.value &&
  //                       selected?.value
  //                     ) {
  //                       try {
  //                         const query = {
  //                           state: watch("state").value,
  //                           city: watch("city").value,
  //                           owner: watch("owner").value,
  //                           property: useData.property.id,
  //                         };
  //                         const res = await get(
  //                           `${
  //                             URLS.OWNER_WALLET_DROPDOWNLIST
  //                           }?${new URLSearchParams(query)}`
  //                         );
  //                         if (res?.status === "success") {
  //                           const formatted = res?.data?.bookings.map(
  //                             (item) => ({
  //                               value: item.id,
  //                               label: item.booking_code,
  //                             })
  //                           );
  //                           console.log("res.data", formatted);
  //                           setBookingData(formatted);
  //                         }
  //                       } catch (err) {
  //                         console.error("Error fetching booking data:", err);
  //                       }
  //                     }
  //   }

  //   if (useData?.booking_code && useData?.booking_code) {
  //     setValue("booking", {
  //       value: useData.booking_code,
  //       label: useData.booking_code,
  //     });
  //   }
  // }, [useData]);
  useEffect(() => {
    const initializeFormData = async () => {
      if (useData?.city_id && useData?.city) {
        setValue("city", { value: useData.city_id, label: useData.city });
        fetchDropdownData(
          {
            state: watch("state").value,
            city: useData.city_id,
          },
          "owners"
        );
      }

      if (useData?.owner_id && useData?.owner_name) {
        setValue("owner", {
          value: useData.owner_id,
          label: `${useData.owner_name}${useData.owner_mobile ? ` - ${useData.owner_mobile}` : ""
            }${useData.owner_code ? ` | ${useData.owner_code}` : ""}`,
        });
        fetchDropdownData(
          {
            state: watch("state").value,
            city: watch("city").value,
            owner: useData.owner_id,
          },
          "properties"
        );
      }

      if (useData?.property?.code && useData?.property?.name) {
        setValue("property", {
          value: useData.property.id,
          label: `${useData.property.name}${useData.property.code ? ` | ${useData.property.code}` : ""
            }`,
        });

        if (
          watch("state")?.value &&
          watch("city")?.value &&
          watch("owner")?.value &&
          useData.property.id
        ) {
          try {
            const query = {
              state: watch("state").value,
              city: watch("city").value,
              owner: watch("owner").value,
              property: useData.property.id,
            };
            const res = await get(
              `${URLS.OWNER_WALLET_DROPDOWNLIST}?${new URLSearchParams(query)}`
            );
            if (res?.status === "success") {
              const formatted = res?.data?.bookings.map((item) => ({
                value: item.id,
                label: item.booking_code,
              }));
              console.log("res.data", formatted);
              setBookingData(formatted);
            }
          } catch (err) {
            console.error("Error fetching booking data:", err);
          }
        }
      }

      if (useData?.booking_code) {
        setValue("booking", {
          value: useData.booking_code,
          label: useData.booking_code,
        });
      }
    };

    initializeFormData();
  }, [useData]);
  console.log("bookingData", setReject);
  return (
    <>
      <Topbar header={"Owner"} subHead={"Wallet Owner"} />
      <div className="row mt-5">
        <form
          className="d-flex flex-wrap gap-5"
          onSubmit={handleSubmit(onSubmit)}
        >
          {/* STATE */}
          <div className="col-md-5">
            <Controller
              control={control}
              name="state"
              rules={{ required: "State is required" }}
              render={({ field }) => (
                <div>
                  <label>
                    State<span style={{ color: "red" }}>*</span>
                  </label>
                  <Select
                    {...field}
                    options={lists.states}
                    placeholder="Select State"
                    isSearchable
                    value={field.value}
                    styles={customStyles}
                    isDisabled={
                      isViewMode || loading.states || formType === "edit"
                    }
                    isLoading={loading.states}
                    onChange={(selected) => {
                      field.onChange(selected);
                      setValue("city", null);
                      setValue("owner", null);
                      setValue("property", null);
                      setValue("booking", null);
                      setLists((prev) => ({
                        ...prev,
                        cities: [],
                        owners: [],
                        properties: [],
                      }));
                      if (selected?.value)
                        fetchDropdownData({ state: selected.value }, "cities");
                    }}
                  />
                  {errors.state && (
                    <p style={{ color: "red" }}>{errors.state.message}</p>
                  )}
                </div>
              )}
            />
          </div>

          {/* CITY */}
          <div className="col-md-5">
            <Controller
              control={control}
              name="city"
              rules={{ required: "City is required" }}
              render={({ field }) => (
                <div>
                  <label>
                    City<span style={{ color: "red" }}>*</span>
                  </label>
                  <Select
                    {...field}
                    options={lists.cities}
                    placeholder="Select City"
                    isSearchable
                    value={field.value}
                    styles={customStyles}
                    isDisabled={
                      !watch("state") ||
                      isViewMode ||
                      loading.cities ||
                      formType === "edit"
                    }
                    isLoading={loading.cities}
                    onChange={(selected) => {
                      field.onChange(selected);
                      setValue("owner", null);
                      setValue("property", null);
                      setValue("booking", null);
                      setLists((prev) => ({
                        ...prev,
                        owners: [],
                        properties: [],
                      }));
                      if (watch("state")?.value && selected?.value)
                        fetchDropdownData(
                          {
                            state: watch("state").value,
                            city: selected.value,
                          },
                          "owners"
                        );
                    }}
                  />
                  {errors.city && (
                    <p style={{ color: "red" }}>{errors.city.message}</p>
                  )}
                </div>
              )}
            />
          </div>

          {/* OWNER */}
          <div className="col-md-5">
            <Controller
              control={control}
              name="owner"
              rules={{ required: "Owner is required" }}
              render={({ field }) => {
                console.log("DLADSLSAA", field);
                return (
                  <div>
                    <label>
                      Owner<span style={{ color: "red" }}>*</span>
                    </label>
                    <Select
                      {...field}
                      options={lists.owners}
                      placeholder="Select Owner"
                      isSearchable
                      value={field.value}
                      styles={customStyles}
                      isDisabled={
                        !watch("city") ||
                        isViewMode ||
                        loading.owners ||
                        formType === "edit"
                      }
                      isLoading={loading.owners}
                      onChange={(selected) => {
                        field.onChange(selected);
                        setValue("property", null);
                        setValue("booking", null);
                        setLists((prev) => ({ ...prev, properties: [] }));
                        if (
                          watch("state")?.value &&
                          watch("city")?.value &&
                          selected?.value
                        ) {
                          fetchDropdownData(
                            {
                              state: watch("state").value,
                              city: watch("city").value,
                              owner: selected.value,
                            },
                            "properties"
                          );
                        }
                      }}
                    />
                    {errors.owner && (
                      <p style={{ color: "red" }}>{errors.owner.message}</p>
                    )}
                  </div>
                );
              }}
            />
          </div>

          {/* PROPERTY */}
          <div className="col-md-5">
            <Controller
              control={control}
              name="property"
              // rules={{ required: "Property is required" }}
              render={({ field }) => (
                <div>
                  <label>
                    Property
                    {/* Property<span style={{ color: "red" }}>*</span> */}
                  </label>
                  <Select
                    {...field}
                    options={lists.properties}
                    placeholder="Select Property"
                    isSearchable
                    value={field.value}
                    styles={customStyles}
                    isDisabled={
                      !watch("owner") ||
                      isViewMode ||
                      loading.properties ||
                      formType === "edit"
                    }
                    isLoading={loading.properties}
                    onChange={async (selected) => {
                      field.onChange(selected);
                      if (
                        watch("state")?.value &&
                        watch("city")?.value &&
                        watch("owner")?.value &&
                        selected?.value
                      ) {
                        try {
                          const query = {
                            state: watch("state").value,
                            city: watch("city").value,
                            owner: watch("owner").value,
                            property: selected.value,
                          };
                          const res = await get(
                            `${URLS.OWNER_WALLET_DROPDOWNLIST
                            }?${new URLSearchParams(query)}`
                          );
                          if (res?.status === "success") {
                            const formatted = res?.data?.bookings.map(
                              (item) => ({
                                value: item.id,
                                label: item.booking_code,
                              })
                            );
                            console.log("res.data", formatted);
                            setBookingData(formatted);
                          }
                        } catch (err) {
                          console.error("Error fetching booking data:", err);
                        }
                      }
                    }}
                  />
                  {/* {errors.property && (
                    <p style={{ color: "red" }}>{errors.property.message}</p>
                  )} */}
                </div>
              )}
            />
          </div>

          {/* BOOKING (Optional) */}
          <div className="col-md-5">
            <Controller
              control={control}
              name="booking"
              render={({ field }) => (
                <div>
                  <label>Booking Id (optional)</label>
                  <Select
                    {...field}
                    options={bookingData || []}
                    placeholder="Select Booking"
                    isSearchable
                    value={field.value}
                    styles={customStyles}
                    isDisabled={isViewMode}
                  />
                </div>
              )}
            />
          </div>

          {/* WALLET AMOUNT */}
          <div className="col-md-5">
            <Controller
              control={control}
              name="WalletAmount"
              rules={{ required: "Wallet Amount is required" }}
              render={({ field }) => (
                <div>
                  <label>
                    Wallet Amount<span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    {...field}
                    className="input-box"
                    placeholder="Enter Wallet Amount"
                    disabled={isViewMode}
                    type="number"
                  />
                  {errors.WalletAmount && (
                    <p style={{ color: "red" }}>
                      {errors.WalletAmount.message}
                    </p>
                  )}
                </div>
              )}
            />
          </div>

          {/* REQUESTED BY */}
          <div className="col-md-5">
            <Controller
              control={control}
              name="RequestedBy"
              render={({ field }) => (
                <div>
                  <label>
                    Requested By <span style={{ color: "red" }}>*</span>
                  </label>
                  <input {...field} className="input-box" disabled />
                </div>
              )}
            />
          </div>

          {/* DESCRIPTION */}
          <div className="col-md-11">
            <Controller
              control={control}
              name="Description"
              rules={{ required: "Description is required" }}
              render={({ field }) => (
                <div style={{ width: "95%" }}>
                  <label>
                    Description<span style={{ color: "red" }}>*</span>
                  </label>
                  <textarea
                    {...field}
                    className="input-box"
                    placeholder="Enter description..."
                    style={{ minHeight: "131px" }}
                    disabled={isViewMode}
                  />
                  {errors.Description && (
                    <p style={{ color: "red" }}>{errors.Description.message}</p>
                  )}
                </div>
              )}
            />
          </div>

          {/* BUTTONS */}

          {/* {formType === "edit" && (
            <>
              <div className="col-lg-11 d-flex gap-3 mt-3">
                <button
                  type="button"
                  className="approve-btn f2"
                  onClick={accept}
                >
                  Approve
                </button>
                <button
                  type="button"
                  className="reject1-btn f2"
                  onClick={() => setShowReason(true)}
                >
                  Reject
                </button>
              </div>

              {showReason && (
                <>
                  <div className="col-md-11" ref={inputRef}>
                    <Controller
                      control={control}
                      name="Reason"
                      rules={{ required: "Reason is required" }}
                      render={({ field }) => (
                        <div style={{ width: "95%" }}>
                          <label>
                            Reject Reason<span style={{ color: "red" }}>*</span>
                          </label>
                          <textarea
                            {...field}
                            className="input-box"
                            placeholder="Enter reason..."
                            style={{ minHeight: "131px" }}
                          />
                          {errors.Reason && (
                            <p style={{ color: "red" }}>
                              {errors.Reason.message}
                            </p>
                          )}
                        </div>
                      )}
                    />
                  </div>

                  <div
                    className="col-lg-11 justify-content-end d-flex"
                    style={{ width: "87%" }}
                  >
                    <button
                      type="button"
                      className="submit-btn f2 mt-3"
                      onClick={() => reject(watch("Reason"))}
                    >
                      Submit
                    </button>
                  </div>
                </>
              )}
            </>
          )} */}
          {formType === "add" && (
            <div
              className="col-lg-11 justify-content-end d-flex "
              style={{ width: "87%" }}
            >
              <button
                onSubmit={handleSubmit(onSubmit)}
                type="submit"
                className="submit-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3  "
              >
                Add
              </button>
            </div>
          )}

          {setReject && (
            <div
              className="col-lg-11 justify-content-end d-flex "
              style={{ width: "87%" }}
            >
              <button
                onSubmit={handleSubmit(onSubmit)}
                type="submit"
                className="submit-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3  "
              >
                Update
              </button>
            </div>
          )}

          {formType === "edit" && !setReject && (
            <>
              <div className="col-lg-11 justify-content-start ">
                <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                  Description<span style={{ color: "red" }}>*</span>
                </label>
                <div className="d-flex as-js gap-5">
                  <button
                    type="button"
                    className="approve-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3"
                    onClick={accept}
                  >
                    Approve
                  </button>

                  <button
                    type="button"
                    className="reject1-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3"
                    onClick={() => {
                      setShowReason(true);
                    }}
                  >
                    Reject
                  </button>
                </div>
              </div>
            </>
          )}
          {showReason && (
            <>
              <div className="col-md-11" ref={inputRef}>
                <Controller
                  control={control}
                  name="Reason"
                  rules={{ required: "Reason is required" }}
                  render={({ field }) => (
                    <div style={{ width: "95%" }}>
                      <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                        Reason<span style={{ color: "red" }}>*</span>
                      </label>
                      <textarea
                        className="input-box"
                        placeholder="Enter reason..."
                        {...field}
                        style={{ minHeight: "131px" }}
                        disabled={isReject}
                      />
                      {errors.Reason && (
                        <p style={{ color: "red" }}>{errors.Reason.message}</p>
                      )}
                    </div>
                  )}
                />
              </div>
              {formType === "edit" && (
                <div
                  className="col-lg-11 justify-content-end d-flex"
                  style={{ width: "87%" }}
                >
                  <button
                    type="button"
                    className="submit-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3"
                    onClick={reject}
                  >
                    Submit
                  </button>
                </div>
              )}
            </>
          )}
        </form>
      </div>
    </>
  );
};

export default WalletOwnerAdd;
